export const parseMapConfig = (mapConfigString?: string) => {
	if (!mapConfigString) {
		return {};
	}

	const mapConfig = JSON.parse(mapConfigString);
	if (
		!!mapConfig.maxBoundsPolygon &&
		typeof mapConfig.maxBoundsPolygon === 'string'
	) {
		mapConfig.maxBoundsPolygon = JSON.parse(mapConfig.maxBoundsPolygon);
	}
	return mapConfig;
};
